<template>
  <div>
    <div class="container-fluid" style="height: 65px">
     

      <div class="table-responsive" style="border: 1px solid #f5a623">
        <table class="table table-white">
          <thead>
            <tr  >

              <th scope="col">Corbeille</th>
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="corbeille in corebeilles" v-bind:key="corbeille.id">
              <td>
                <router-link
                    style="color: black"
                    :to="{
                      name: 'show',
                      query: {
                        model: corbeille.model,
                      },
                    }"
                  >
               {{ corbeille.text }}

               </router-link>
                
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>


<script>
import { apiDomain } from "../../config";
import axios from "axios";
import HighlightWords from "vue-highlight-words";

import Highlighter from "vue-highlight-words";
export default {
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  components: {
    Highlighter,
    HighlightWords,
  },
  data() {
    return {
   
      corebeilles: [
        { id: 1, text: "Bloc note",model:"blocs" },
        { id: 2, text: "Detail blocs ",model:"detail_blocs" },

        { id: 3, text: "Facture vidange",model:"factures_vidanges" },
        { id: 4, text: "Detail services",model:"detail_services" },
        { id: 5, text: "Factures services",model:"factures" },
        { id: 6, text: "Factures vidanges",model:"factures_vidanges" },

        { id: 7, text: "Kilometrages",model:"kilometrages" },
        { id: 8, text: "Kilometrages vidanges",model:"kilometrages_vidanges" },

        { id: 9, text: "Matricules",model:"mats" },
        { id: 10, text: "Vidanges",model:"vidanges" },
        { id: 11, text: "Retenus",model:"retenus" },
        { id: 12, text: "Services",model:"services" },
        { id: 13, text: "Societe servies",model:"societe_servies" },
        { id: 14, text: "Traitements",model:"sraitements" }, 
        { id: 15, text: "Services",model:"services" },
        { id: 16, text: "Trait vidanges",model:"trait_vidange" },
      

      ],
  
    };
  },

  created() {
    //this.fetchListesTypes();
    this.fetchsearch();
    this.loadBlocNote();
  },

  computed: {
    filteredBlocNote: function () {
      if (Array.isArray(this.listes_bloc_note)) {
        return this.listes_bloc_note.filter((pack) => {
          return (
            pack.nom.match(this.search) || pack.created_at.match(this.search)
          );
        });
      }
    },
  },

  methods: {
 
    delete_bloc_note(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/deleteBloque/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Bloc note  supprimer avec Succès ! ");
          this.loadBlocNote();
        })

        .catch((err) => console.log(err));
      }
    },
    /* new azouz 2021 */
    keywords() {
      return this.search.split(" ");
    },

    loadBlocNote() {
      axios
        .get(`${apiDomain}/api/get_all_Bloque`)
        .then((response) => {
          this.listes_bloc_note = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    /* fin new 2022 */
    fetchsearch() {
      if (this.q.length > 1) {
        axios
          .get(`${apiDomain}/api/Listes_services_ajouter/` + this.q)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      } else {
        axios
          .get(`${apiDomain}/api/Listes_services_ajouter`)
          .then((res) => (this.listes_service = res.data))
          .catch((error) => console.log(error));
      }
    },
    /*  delete_service(id) {
      fetch(`${apiDomain}/api/delete_service/${id}`, {
        method: 'delete',
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success('Service  supprimer avec Succès ! ')

          this.fetchsearch()
        })

        .catch((err) => console.log(err))
    }, */
    /*   fetchListesTypes() {
      fetch(`${apiDomain}/api/Listes_services_ajouter`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_service = res.all_service.data;
        })
        .catch((err) => console.log(err));
    }, */
  },
};
</script>

<style>
.feed {
  background: #fff;
  height: 106px;
  overflow: scroll;
}
.btdelete {
  padding: 11px 27px !important;
  margin-top: 38px;
  border-radius: 5px;
}
/* 
.md-card img {
  width: 55% !important;
  height: auto;
} */
</style>

